import * as React from 'react';
import { Box, type BoxT } from '../box';
import { RadioGroupContext } from './RadioGroupContext';

export interface RadioGroup<T = string | number>
  extends Omit<BoxT, 'onChange'> {
  value: T | undefined;
  name: string;
  onChange: (value: T) => void;
}

export const RadioGroup = <T,>({
  value,
  name,
  onChange,
  children,
  ...boxProps
}: RadioGroup<T>) => {
  const contextValue = {
    value,
    name,
    onChange,
  };
  return (
    <RadioGroupContext.Provider value={contextValue}>
      <Box as="fieldset" {...boxProps}>
        {children}
      </Box>
    </RadioGroupContext.Provider>
  );
};
